module.exports = __webpack_public_path__ + "static/media/logo.a9934040.png";